import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {StsConfigHttpLoader} from 'angular-auth-oidc-client';
import {baseAuthConfig, loginPathConfig} from '../config';

export const configLoaderFactory = (httpClient: HttpClient) => {
    const config$ = httpClient.get<any>(loginPathConfig.NMDPLoginConfigPath).pipe(
        map((customConfig: any) => {
            return {
                ...baseAuthConfig,
                ...customConfig
            };
        })
    );

    return new StsConfigHttpLoader(config$);
};
